module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    staticStyle: {
      "border-top": "5px solid #7eb210"
    },
    attrs: {
      "id": "newsletter-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "#7eb210"
    }
  }, [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message0')))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://youtu.be/OX9-oycPK2I?list=PLOe2USAqjKqA66C7hpaWdLWD8PDw0NH_V",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('video1')))])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://youtu.be/6g8eHXN6_mY?list=PLOe2USAqjKqA66C7hpaWdLWD8PDw0NH_V",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('video2')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc8bfb9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/components/newsletter-modal/newsletter-modal.vue
// module id = 305
// module chunks = 0